// created by AI
import { matchesFilterSearchWithWildcard } from "open-lib"

// created by AI
// Sensor labels often combine equipment names and numbers, like "DG1 Power".
// Adding spaces around digit groups gives the normal token search another
// representation to inspect, so "dg power" can match "DG1 Power".
export function expandAlphaNumericBoundaries(searchText: string): string {
	return searchText
		.replace(/([A-Za-z])([0-9])/g, "$1 $2")
		.replace(/([0-9])([A-Za-z])/g, "$1 $2")
}

// created by AI
// Keep the existing select search behavior first, including wildcard support, then
// try the alpha/numeric-expanded label as a fallback for compact sensor names.
export function matchesSelectableLabelSearch(searchText: string, labelText: string): boolean {
	return (
		matchesFilterSearchWithWildcard(searchText, labelText) ||
		matchesFilterSearchWithWildcard(searchText, expandAlphaNumericBoundaries(labelText))
	)
}
